import { render, staticRenderFns } from "./Prize_shop_order.vue?vue&type=template&id=1c20df2f&scoped=true"
import script from "./Prize_shop_order.vue?vue&type=script&lang=js"
export * from "./Prize_shop_order.vue?vue&type=script&lang=js"
import style0 from "./Prize_shop_order.vue?vue&type=style&index=0&id=1c20df2f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20df2f",
  null
  
)

export default component.exports